import { Link } from 'react-router-dom'
import { BAKERY_RECIPES } from '../../data/bakeryRecipes'

export function BakeRecipeListView() {
  return (
    <div className="page page--bake-list">
      <header className="bake-list-header">
        <Link to="/bakery" className="btn-back" aria-label="Back to bakery">←</Link>
        <h1 className="bake-list-title">What do you want to bake?</h1>
        <p className="bake-list-meta">{BAKERY_RECIPES.length} recipes to try</p>
      </header>
      <p className="bake-list-intro">
        Tap a recipe. Follow the steps in the app – and you can do them in real life too!
      </p>
      <ul className="bake-list-grid" aria-label="Recipes">
        {BAKERY_RECIPES.map((recipe) => (
          <li key={recipe.id}>
            <Link
              to={`/bakery/bake/${recipe.id}`}
              className="bake-list-card"
              aria-label={`Bake ${recipe.name}`}
            >
              <span className="bake-list-card-emoji" aria-hidden>{recipe.emoji}</span>
              <span className="bake-list-card-name">{recipe.name}</span>
              {recipe.description && (
                <span className="bake-list-card-desc">{recipe.description}</span>
              )}
              <span className="bake-list-card-steps">{recipe.steps.length} steps</span>
            </Link>
          </li>
        ))}
      </ul>
      <Link to="/bakery" className="btn-large btn-secondary bake-list-back" style={{ textDecoration: 'none' }}>
        Back to Bakery
      </Link>
    </div>
  )
}
